import { render, staticRenderFns } from "./system-statuses.vue?vue&type=template&id=9c6b845e&scoped=true"
import script from "./system-statuses.vue?vue&type=script&lang=js"
export * from "./system-statuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6b845e",
  null
  
)

export default component.exports